import api from "../axios";

export const listDepartments = (params) => api.get("departments/", { params });
export const createDepartment = (data) => api.post("departments/", data);
export const updateDepartment = (id, data) =>
  api.put(`departments/${id}/`, data);
export const patchDepartment = (id, data) =>
  api.patch(`departments/${id}/`, data);
export const deleteDepartment = (id) => api.delete(`departments/${id}/`);
